import { ReportPeriodControlComponent } from '../../report-period-control/report-period-control.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DxButtonModule,
  DxFormModule,
  DxScrollViewModule,
  DxSwitchModule,
  DxTagBoxModule,
  DxTooltipModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { ReportSettingsFormComponent } from './report-settings-form.component';

@NgModule({
  declarations: [ReportSettingsFormComponent],
  imports: [
    CommonModule,
    ReportPeriodControlComponent,
    DxButtonModule,
    DxFormModule,
    DxScrollViewModule,
    DxSwitchModule,
    DxTagBoxModule,
    DxTooltipModule,
    DxValidatorModule,
  ],
  exports: [ReportSettingsFormComponent],
})
export class ReportSettingsFormModule {}
